define(['underscore'], (_)=> {

    return ['$rootScope', 'StateUtils', 'EventHub', 'LocaleService', ($rootScope, StateUtils, EventHub, LocaleService) => {

        $rootScope.$on('$stateChangeSuccess', (event, toState, params) => {
            const path = StateUtils.getTrackingUrl(toState, params);
            const {model} = StateUtils.activeDataForState(true);

            let mPackagePremium;

            if (model && model.quoteData.value) {
                const mPackage = _.findWhere(model.quoteData.offeredQuotes.value, {offeringShortName: 'M'});
                mPackagePremium = (mPackage) ? mPackage.total.amount : undefined;
            }

            let selectedPackagePremium;

            if (model && model.bindData.value && model.quoteData.value) {
                const selectedPackage = _.findWhere(model.quoteData.offeredQuotes.value, {isSelected: true});
                selectedPackagePremium = (selectedPackage) ? selectedPackage.total.amount : undefined;
            }

            let tags;

            if (model && model.draftData && model.draftData.value) {
                if (model.draftData.value.productCode) {
                    tags = `product=${model.draftData.value.productCode}`;
                }
                if (model.draftData.value.subproductCode) {
                    tags = tags ? `${tags};subproduct=${model.draftData.value.subproductCode}` : `subproduct=${model.draftData.value.subproductCode}`;
                } else if (model.draftData.value.subproductInputParam) {
                    tags = tags ? `${tags};subproduct=${model.draftData.value.subproductInputParam}` : `subproduct=${model.draftData.value.subproductInputParam}`;
                }
                if (model.draftData.value.salespointCode) {
                    tags = tags ? `${tags};salespoint=${model.draftData.value.salespointCode}` : `salespoint=${model.draftData.value.salespointCode}`;
                }
            }

            let parameters = {}; // NOSONAR

            let language = ''; // NOSONAR
            switch (LocaleService.getCurrentLocale()) {
                case 'en_US':
                    language = 'EN';
                    break;
                case 'de':
                    language = 'DE';
                    break;
                case 'fr':
                    language = 'FR';
                    break;
                case 'it':
                    language = 'IT';
                    break;
                default:
                    throw new Error('Language not supported');
            }

            switch (path) {
                case 'RiskRelevantData':
                    parameters = {
                        pagename: `Angaben/Rechner/Motorfahrzeug/Versicherung/${language}/BD`,
                        areas: `BD/${language}/Versicherung/Motorfahrzeug/Rechner`,
                        target: 'Motorfahrzeug/Angaben',
                        tag: tags,
                    };
                    break;
                case 'QuotingPage':
                    parameters = {
                        pagename: `Angebot/Rechner/Motorfahrzeug/Versicherung/${language}/BD`,
                        areas: `BD/${language}/Versicherung/Motorfahrzeug/Rechner`,
                        transactionNumber: model.quoteID.value,
                        target: 'Motorfahrzeug/Angaben/Angebot',
                        tval: mPackagePremium,
                        tag: tags,
                    };
                    break;
                case 'PersonificationQualification':
                    parameters = {
                        pagename: `Person/Rechner/Motorfahrzeug/Versicherung/${language}/BD`,
                        areas: `BD/${language}/Versicherung/Motorfahrzeug/Rechner`,
                        target: 'Motorfahrzeug/Angaben/Angebot/Person',
                        tag: tags,
                    };
                    break;
                case 'SummaryPage':
                    parameters = {
                        pagename: `Antrag/Rechner/Motorfahrzeug/Versicherung/${language}/BD`,
                        areas: `BD/${language}/Versicherung/Motorfahrzeug/Rechner`,
                        target: 'Motorfahrzeug/Angaben/Angebot/Person/Antrag',
                        tag: tags,
                    };
                    break;
                case 'ConfirmationPage':
                    parameters = {
                        pagename: `Danke/Rechner/Motorfahrzeug/Versicherung/${language}/BD`,
                        areas: `BD/${language}/Versicherung/Motorfahrzeug/Rechner`,
                        target: 'Motorfahrzeug/Angaben/Angebot/Person/Antrag/Danke',
                        transactionNumber: model.quoteID.value,
                        sales: 1,
                        tval: selectedPackagePremium,
                        tag: tags,
                    };
                    break;
                default:
                    parameters = undefined;
            }

            EventHub.publish('tracking', 'pageView', {path, parameters});
        });
    }];
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/pageViews.js